import { render, staticRenderFns } from "./CreateSubholdingMemoModal.vue?vue&type=template&id=953d07ca&"
import script from "./CreateSubholdingMemoModal.vue?vue&type=script&lang=js&"
export * from "./CreateSubholdingMemoModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateSubholdingMemoModal.vue?vue&type=style&index=0&id=953d07ca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports